import LoginPage from './login/LoginPage.vue';
import RegistrationPage from './registration/RegistrationPage.vue';
import ProfilePage from './profile/ProfilePage.vue';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: {
      title: 'Connexion - Dashboard',
      requiresAuth: false
    }
  },
  {
    path: '/register',
    name: 'register',
    component: RegistrationPage,
    meta: {
      title: 'Inscription',
      requiresAuth: false
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfilePage,
    meta: {
      title: 'Mon Profil',
      requiresAuth: true
    }
  }
];

export default routes;
